import { BookUser, Database, FileText, Globe, Mail, Ticket } from "lucide-react";

import type { IconComponent } from "../ui/icon";
import { fromIsoDate } from "./date";

/**
 * Source types and their icons (redesign phase 5, #455): one map for every
 * place that lists sources: the AI answer block's compact list and the
 * SourceCard rows. v1 `ReferenceType` → `SourceType` is the app's mapping
 * (04, "Sources").
 */
export type SourceType = "document" | "message" | "database" | "memory" | "ticket" | "web";

export const SOURCE_TYPE_ICON: Record<SourceType, IconComponent> = {
  /** A document page (manual, data sheet). */
  document: FileText,
  /** An e-mail: a similar past case. */
  message: Mail,
  /** A row of a connected database table. */
  database: Database,
  /** A Kundenhistorie fact about the contact. */
  memory: BookUser,
  /** An external ticket. */
  ticket: Ticket,
  /** A web page. */
  web: Globe,
};

/**
 * The date a source's CONTENT is from, as a Date: an ISO `yyyy-mm-dd` string
 * (the API's shape), an ISO timestamp, or a Date. Missing, malformed or
 * invalid → null, so a card never shows "Invalid Date" (as v1
 * `SourceContentDate`).
 */
export function sourceDate(value: string | Date | null | undefined): Date | null {
  if (!value) return null;
  // A bare `yyyy-mm-dd` is a calendar date (no UTC shift); a timestamp is a moment.
  const date = typeof value !== "string" ? value : value.length === 10 ? fromIsoDate(value) : new Date(value);
  return date && !Number.isNaN(date.getTime()) ? date : null;
}
